import { makeStyles } from '@material-ui/core/styles';
import { ISpcTheme } from '../../../../../common/theme/ISpcTheme';

export type CardHeaderClasses =
  | 'container'
  | 'image'
  | 'imageContainer'
  | 'title'
  | 'imageUnavailable'
  | 'cornerLabel'
  | 'cornerContainer'
  | 'label'
  | 'pricing'
  | 'exactLabel';

const cardHeaderStyles = makeStyles<ISpcTheme, CardHeaderClasses>(
  theme => ({
    container: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      padding: `0 20px`,
      position: 'relative',
    },
    title: {
      marginTop: 26,
      padding: '0 32px',
      fontWeight: theme.typography.fontWeightRegular,
      textAlign: 'center',
    },
    imageContainer: {
      display: 'block',
    },
    image: {
      maxWidth: '100%',
      margin: 'auto',
      display: 'block',
      objectFit: 'contain',
      cursor: 'pointer',
    },
    imageUnavailable: {
      maxWidth: '100%',
    },
    cornerContainer: {
      overflow: 'hidden',
      position: 'absolute',
      left: -1,
      top: -1,
      width: 60,
      height: 60,
    },
    cornerLabel: {
      display: 'flex',
      alignItems: 'end',
      justifyContent: 'center',
      width: 100,
      height: 50,
      position: 'absolute',
      top: -12,
      left: -38,
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
      transform: 'rotate(-45deg)',
    },
    exactLabel: {
      backgroundColor: theme.palette.primary.light,
    },
    label: {
      marginTop: '28px',
      textTransform: 'uppercase',
      color: theme.palette.common.white,
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: 2,
      fontSize: theme.typography.fontXS,
    },
    pricing: {
      padding: '16px 0',
    },
  }),
  { name: 'StockLite_CardHeader' },
);

export default cardHeaderStyles;
